import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "coupe"
const CoupeIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.011 9.188C12.303 9.188 12.586 9.285 12.817 9.464L15.85 11.824 21.214 12.138C21.96 12.183 22.437 12.926 22.206 13.608V16.125C22.206 16.85 21.618 17.438 20.893 17.438H19.523C19.069 18.222 18.22 18.75 17.25 18.75S15.431 18.222 14.977 17.438H9.397C8.945 18.222 8.098 18.75 7.126 18.75S5.306 18.222 4.852 17.438H3.357C2.86 17.438 2.405 17.156 2.183 16.712L1.779 15.905C1.623 15.593 1.598 15.233 1.708 14.903L1.956 14.158V12.375C1.956 11.65 2.543 11.063 3.268 11.063H4.646L8.513 9.305C8.682 9.228 8.868 9.188 9.056 9.188zM7.125 15C6.504 15 6 15.504 6 16.125S6.504 17.25 7.125 17.25 8.25 16.746 8.25 16.125 7.746 15 7.125 15M17.25 15C16.629 15 16.125 15.504 16.125 16.125S16.629 17.25 17.25 17.25 18.375 16.746 18.375 16.125 17.871 15 17.25 15M4.89 12.188H3.268C3.165 12.188 3.081 12.27 3.081 12.375V13.688H3.375C3.685 13.688 3.938 13.939 3.938 14.25 3.938 14.56 3.686 14.813 3.375 14.813H2.924L2.775 15.258C2.76 15.305 2.763 15.357 2.785 15.4L3.19 16.21C3.221 16.272 3.286 16.313 3.357 16.313H4.508Q4.501 16.22 4.5 16.125C4.5 14.675 5.675 13.5 7.125 13.5S9.75 14.675 9.75 16.125Q9.75 16.22 9.743 16.313H14.633Q14.626 16.22 14.625 16.125C14.625 14.675 15.8 13.5 17.25 13.5S19.875 14.675 19.875 16.125Q19.875 16.22 19.868 16.313H20.893C20.997 16.313 21.081 16.229 21.081 16.125V15.188H21C20.69 15.188 20.438 14.936 20.438 14.625S20.689 14.063 21 14.063H21.08V13.367L21.134 13.26 15.623 12.939H8.133C7.522 12.938 7.167 12.248 7.521 11.752L8.326 10.625zM8.86 11.812H14.005L12.126 10.353Q12.076 10.312 12.011 10.312H9.932z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CoupeIcon
